import React from "react";
import locales from "../../../_constants/locales";
import "../Styles/_OrderFetchErrorPage.css";

const OrderFetchErrorPage = ({ store, language }) => {
    const locale = locales[store[0]][language];
    const { FETCH_ERROR_PAGE, MISC } = locale;

    return (
        <section className="fit layout vertical center-center fetch-error-page">
            <h2>{FETCH_ERROR_PAGE.TITLE}</h2>
            <span className="thick-divider" />
            <p className="description">{FETCH_ERROR_PAGE.DESCRIPTION}</p>
            <p className="help-message">
                {`${FETCH_ERROR_PAGE.HELP_MESSAGE} `}
                <a href={MISC.HELP_LINK} className="help-link">
                    {MISC.HELP_LINK}
                </a>
            </p>
        </section>
    );
};

export default OrderFetchErrorPage;
